
export default {
  getURLParam:function(name, uri) {
    uri = uri || window.location.href;
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(uri);
    if (results === null)
      return "";
    else
      return results[1];
  },
}